// extracted by mini-css-extract-plugin
export default {"root":"UtilitiesCreatePage_root__x1mS5","body":"UtilitiesCreatePage_body__KO9Lc"};